module.exports = __webpack_public_path__ + "fonts/Roboto-Bold.d329cc8b.ttf";